const addListener = (element: Element | Window, eventName: string, eventHandler: any) => {
  element.addEventListener(eventName, eventHandler);

  return function cleaner() {
    element.removeEventListener(eventName, eventHandler);
  };
};

const addWindowListener = (eventName: string, eventHandler: any) => {
  return addListener(window, eventName, eventHandler);
};

export { addListener, addWindowListener };
